<ng-container *transloco="let t">
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingVatCondition') }}</div>
    <div class="order-section-item-value">{{ vatCondition() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingName') }}</div>
    <div class="order-section-item-value">{{ billingName() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingDocument') }}</div>
    <div class="order-section-item-value">
      {{ billingDocument() }}
    </div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">
      {{
        isVatConditionBusiness()
          ? t('orderDetails.billingBusinessAddress')
          : t('orderDetails.billingAddress')
      }}
    </div>
    <div class="order-section-item-value">{{ billingAddress() }}</div>
  </div>

  @if (adminMode()) {
    @if (
      canGenerateTaxVoucher() && !taxVoucherSummary() && requiredDataCompleted() && isNotCanceled()
    ) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.billingTitle') }}</div>
        <div class="order-section-item-value">
          <pxw-button
            style="margin-left: 10px"
            size="sm"
            [rounded]="true"
            display="inline"
            color="yellow"
            (click)="onGenerateTaxVoucher()"
          >
            <pxw-icon icon="billing-voucher" />
            {{ t('Facturar pedido') }}
          </pxw-button>
        </div>
      </div>
    }

    @let _taxVoucherSummary = taxVoucherSummary();

    @if (_taxVoucherSummary) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.taxVoucher') }}</div>
        <div class="order-section-item-value">
          <div style="display: flex; align-items: center; gap: 10px">
            <app-tax-voucher-actions
              [taxVoucherInput]="_taxVoucherSummary"
              [displayTaxVoucherType]="true"
              [displayCreditNoteAction]="_taxVoucherSummary.associatedTaxVoucherRef == null"
            />
          </div>
        </div>
      </div>
    }
  }
  <!-- Modal de creación de facturas -->
  <pxw-create-voucher-modal
    [establishment]="establishment()"
    [electronicBillingIntegration]="electronicBillingIntegration()"
  />
</ng-container>
